import React, { useState, useEffect } from "react";
import { FaArrowRight } from "react-icons/fa";
import '../css/bootstrap-select.min.css';
import '../css/bootstrap-slider.min.css';
import '../css/bootstrap.min.css';

import '../css/flaticon.min.css';
import '../css/loader.min.css';
import '../css/magnific-popup.min.css';
import '../css/Navbar.css'; 
import '../css/style.css';

import '../css/skin/skin-1.css';
import '../plugins/revolution/revolution/css/settings.css';
import '../plugins/revolution/revolution/css/navigation.css';

import '../css/fontawesome/css/font-awesome.min.css';
import '../css/fontawesome/fonts/fontawesome-webfont.eot';
import '../css/fontawesome/fonts/fontawesome-webfont.svg';
import '../css/fontawesome/fonts/fontawesome-webfont.ttf';
import '../css/fontawesome/fonts/fontawesome-webfont.woff';
import '../css/fontawesome/fonts/fontawesome-webfont.woff2';
import '../css/owl.carousel.min.css';
import '../css/fontawesome/less/animated.less';

import '../css/fontawesome/less/bordered-pulled.less';
import '../css/fontawesome/less/core.less';
import '../css/fontawesome/less/fixed-width.less';
import '../css/fontawesome/less/font-awesome.less';
import '../css/fontawesome/less/icons.less';
import '../css/fontawesome/less/larger.less';
import '../css/fontawesome/less/list.less';
import '../css/fontawesome/less/mixins.less';
import '../css/fontawesome/less/path.less';
import '../css/fontawesome/less/rotated-flipped.less';
import '../css/fontawesome/less/screen-reader.less';
import '../css/fontawesome/less/stacked.less';

function Shareholdingpattern() {
  const [currentDocuments, setCurrentDocuments] = useState([]);
  const [archivedDocuments, setArchivedDocuments] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);

  useEffect(() => {
    const fetchShareHoldingData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_Backend_URL}/share/shareHoldingDocument`
        );

        if (response.ok) {
          const result = await response.json();
          if (result.success) {
            setCurrentDocuments(result.data.current);
            setArchivedDocuments(result.data.archived);
          } else {
            console.error("Failed to fetch shareholding data.");
          }
        } else {
          console.error(`Error fetching data: ${response.statusText}`);
        }
      } catch (error) {
        console.error("Error fetching shareholding data:", error);
      }
    };

    fetchShareHoldingData();
  }, []);

  const handleViewClick = (fileUrl) => {
    setSelectedPdf(fileUrl);
  };

  const handleClosePreview = () => {
    setSelectedPdf(null);
  };

  return (
    <>

  <div className="banner-shareholding">
    <div className="overlay-shareholding" />
    <div className="banner-content animate__animated animate__fadeIn">
      <h1 className="h1-shareholding3">Shareholding Pattern</h1>
    </div>
  </div>
  <br />
  <br />
  <section className="pdf-links">
        <h2>Shareholding Pattern Reports</h2>
        <ul>
          {currentDocuments.length === 0 ? (
            <li>No current financial data available. Please check back later.</li>
          ) : (
            currentDocuments.map((doc) => (
              <li key={doc._id}>
                <div className="pdf-item">
                  <p className="year-title">
                    {doc.title} - {doc.year}
                  </p>
                  <a
                    href={doc.file}
                    className="view-link"
                    onClick={() => handleViewClick(doc.file)}
                  >
                    <FaArrowRight />
                  </a>
                </div>
              </li>
            ))
          )}
        </ul>
        </section>
</>

  );
}

export default Shareholdingpattern;